import { useEffect, useRef } from "react";

/**
 *
 * @param currentValue
 * @returns The latest value in previous renders that is not undefined
 */
export function useDefinedPreviousValue(currentValue: any) {
  const ref = useRef(currentValue);
  useEffect(() => {
    if (typeof currentValue !== "undefined") {
      ref.current = currentValue;
    }
  });
  return ref.current;
}
